<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import AuthApi from "@/services/auth-api";
import UsersApi from "@/services/users-api";
import Vue from "vue";
import NprogressContainer from "vue-nprogress/src/NprogressContainer";

/**
 * Login component
 */
export default {
  page: {
    title: "Authentification",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    NprogressContainer,
    FormWizard,
    TabContent
  },
  data() {
    return {
      email: "",
      password: "",
      passwordHidden: true,

      authError: null,
      isAuthError: false,
      tryingToLogIn: false,

      forgetPasswordisClicked: false,
      createNewAccountClicked: false,

      username: "",
      newPassword: "",
      confPassword: "",
      code: "",

      errorMessage: "",
      secondErrorMessage: "",
      showErrorMesage: false,
      showSecondErrorMessage: false,

      newAccountCompanyName: "",
      newAccountCompanyPhone: ""
    };
  },
  methods: {
    ...authMethods,

    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;

      return this.logIn({
        email: this.email,
        password: this.password
      })
        .then(() => this.$router.push({ name: "default" }))
        .catch(error => {
          this.authError = error || "Identifiants incorrects";
          this.isAuthError = true;
          Vue.prototype.$snotify.error(this.authError);
        })
        .finally(() => (this.tryingToLogIn = false));
    },

    createCode() {
      return AuthApi.createCode(this.username, this.newPassword, this.confPassword)
        .catch(err => {
          this.errorMessage = err;
          this.showErrorMesage = true;
          throw err;
        });
    },

    resetPassword() {
      return AuthApi.resetPassword(this.username, this.code)
        .catch(err => {
          this.secondErrorMessage = err;
          this.showSecondErrorMessage = true;
          throw err;
        });
    },

    addAccountRequest() {
      UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(() => {
          Vue.prototype.$snotify.success("Demande envoyée");
          this.createNewAccountClicked = false;
        });
    }
  },

  mounted() {
    document.body.style.background = "#f8fafc";
  }
};
</script>

<template>
  <Layout>
    <nprogress-container />

    <div class="auth-wrapper">
      <div class="auth-bg d-none d-md-flex">
        <div class="auth-bg-content">
          <img src="@/assets/images/logo-white.png" alt="Digitable" class="auth-bg-logo" />
          <h2 class="auth-bg-title">Gérez votre restaurant<br/>depuis un seul endroit</h2>
          <p class="auth-bg-sub">Menu digital, commandes, tableau de bord et bien plus.</p>
        </div>
      </div>

      <div class="auth-content">
        <div class="auth-card">

          <!-- LOGO -->
          <div class="logo">
            <router-link to="/"><img src="@/assets/images/logo.png" alt="Logo" /></router-link>
          </div>

          <!-- LOGIN -->
          <template v-if="!forgetPasswordisClicked && !createNewAccountClicked">
            <h1>Bienvenue</h1>
            <p class="subtitle">Accédez à votre espace professionnel</p>

            <b-alert v-model="isAuthError" variant="danger" class="mb-3">
              {{ authError }}
            </b-alert>

            <b-form @submit.prevent="tryToLogIn">
              <div class="form-group">
                <label>Adresse email</label>
                <input
                  v-model="email"
                  type="email"
                  placeholder="exemple@email.com"
                  required
                />
              </div>

              <div class="form-group">
                <label>Mot de passe</label>
                <div class="password-field">
                  <input
                    v-model="password"
                    :type="passwordHidden ? 'password' : 'text'"
                    placeholder="••••••••"
                    required
                  />
                  <i
                    :class="passwordHidden ? 'fa fa-eye-slash' : 'fa fa-eye'"
                    @click="passwordHidden = !passwordHidden"
                  />
                </div>
              </div>

              <button class="btn-primary" :disabled="tryingToLogIn">
                <span v-if="!tryingToLogIn">Se connecter</span>
                <b-spinner v-else small />
              </button>
            </b-form>

            <div class="links">
              <span @click="forgetPasswordisClicked = true">Mot de passe oublié ?</span>
            </div>
          </template>

          <!-- FORGOT PASSWORD -->
          <template v-if="forgetPasswordisClicked">
            <h1>Réinitialisation</h1>

            <form-wizard color="#1d3266" next-button-text="Suivant" @on-complete="forgetPasswordisClicked=false">
              <tab-content :before-change="createCode">
                <input v-model="username" placeholder="Adresse email" />
                <input v-model="newPassword" type="password" placeholder="Nouveau mot de passe"  class="mt-2"/>
                <input v-model="confPassword" type="password" placeholder="Confirmation" class="mt-2"/>
                <p class="error" v-if="showErrorMesage">{{ errorMessage }}</p>
              </tab-content>

              <tab-content :before-change="resetPassword">
                <input v-model="code" placeholder="Code reçu par email" />
                <p class="error" v-if="showSecondErrorMessage">{{ secondErrorMessage }}</p>
              </tab-content>

              <tab-content>
                <div class="success">
                  <i class="mdi mdi-check-circle"></i>
                  <h3>Mot de passe mis à jour</h3>
                </div>
              </tab-content>
            </form-wizard>

            <span class="back" @click="forgetPasswordisClicked=false">
              ← Retour
            </span>
          </template>


        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* Layout */
.auth-wrapper {
  display: flex;
  min-height: 100vh;
  background: #f4f6fb;
}

.auth-bg {
  flex: 1;
  background: linear-gradient(
      rgba(29, 50, 102, 0.72),
      rgba(29, 50, 102, 0.82)
    ),
    url('~@/assets/images/background/back.png') center/cover no-repeat;
  display: flex;
  align-items: flex-end;
  padding: 3rem;
}

.auth-bg-content {
  color: #fff;
}

.auth-bg-logo {
  max-width: 130px;
  margin-bottom: 2.5rem;
  opacity: 0.92;
}

.auth-bg-title {
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 1rem;
  color: #fff;
}

.auth-bg-sub {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  max-width: 340px;
}

.auth-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 3.5rem;
  background: #fff;
}

/* Card */
.auth-card {
  width: 100%;
  max-width: 400px;
  padding: 0;
  background: transparent;
  animation: fadeInUp 0.5s ease;
}

/* Logo */
.logo {
  text-align: center;
  margin-bottom: 1.75rem;
}

.logo img {
  max-width: 140px;
  cursor: pointer;
}

/* Typography */
h1 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 0.3rem;
  color: #1a1f36;
}

.subtitle {
  font-size: 0.9rem;
  color: #8492a6;
  margin-bottom: 1.75rem;
}

/* Inputs */
.form-group {
  margin-bottom: 1.1rem;
}

label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

input {
  width: 100%;
  padding: 0.7rem 1rem;
  border-radius: 10px;
  border: 1.5px solid #e5e9f0;
  font-size: 0.92rem;
  background: #fafbfc;
  transition: all 0.2s ease;
  color: #1a1f36;
}

input:focus {
  outline: none;
  border-color: #1d3266;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(29, 50, 102, 0.1);
}

/* Password */
.password-field {
  position: relative;
}

.password-field {
  position: relative;
}

.password-field i {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #9aa3b2;
  font-size: 0.9rem;
}

/* Button */
.btn-primary {
  width: 100%;
  margin-top: 0.75rem;
  padding: 0.8rem;
  border-radius: 10px;
  background: #1d3266;
  color: #fff;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: background 0.25s ease, box-shadow 0.25s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #162752;
  box-shadow: 0 8px 20px rgba(29, 50, 102, 0.3);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Links */
.links {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
  font-size: 0.82rem;
}

.links span,
.back {
  cursor: pointer;
  color: #1d3266;
  font-weight: 500;
}

.links span:hover,
.back:hover {
  text-decoration: underline;
}

/* Error */
.error {
  color: #e53e3e;
  font-size: 0.82rem;
  margin-top: 6px;
}

/* Success */
.success {
  text-align: center;
  padding: 1rem 0;
  color: #1d3266;
}

.success i {
  font-size: 3rem;
  color: #38a169;
}

/* Mobile */
@media (max-width: 767px) {
  .auth-content {
    padding: 2rem 1.5rem;
  }
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
